import * as React from 'react';
import { BaseRouteProps } from '../../interfaces';
import { LanguageDataService } from '../../services';
import { NavLink } from 'react-router-dom';
import { LanguageForm } from './LanguageForm';
import { PVAPage } from '../../components';

export class LanguageCreate extends React.Component<BaseRouteProps<{}>> {
    private languageDataService = new LanguageDataService(this.props.notificationService);

    constructor(props: BaseRouteProps<{}>) {
        super(props);

        this.state = {
            originalEntity: undefined
        };

        this.save = this.save.bind(this);
    }

    public render() {
        return (
            <PVAPage>
                <PVAPage.Header>
                    <PVAPage.Header.Title>
                        <NavLink to={`/language`}>
                            <span className="glyphicon glyphicon-triangle-left" />
                        </NavLink>
                        &nbsp;
                        Create Language
                    </PVAPage.Header.Title>
                </PVAPage.Header>

                <PVAPage.Body>
                    <LanguageForm submit={this.save} />
                </PVAPage.Body>

                <PVAPage.Footer />
            </PVAPage>);
    }

    private save(values: any) {
        this.languageDataService.create(values).then((success) => {
            this.props.history.push('/language');
        });
    }
}


// WEBPACK FOOTER //
// ./src/components/language/LanguageCreate.tsx